export default __webpack_public_path__ + "static/media/Category-Pregnancy__1_.96fb6be6.jpg";